import React from 'react';
import times from 'lodash/times';
import { UserActivityItemLoading } from './components/UserActivityItem/UserActivityItem.loading';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';

interface Props {
  showAutomaticAccountUpdatesToggle: boolean;
  showSortFilter?: boolean;
}

export const UserActivityLoading = ({
  showAutomaticAccountUpdatesToggle,
  showSortFilter = true,
}: Props) => {
  return (
    <>
      <Box as="header" position="sticky" top={0} bg="bg" zIndex={1} pb="16">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb="16">
          <Shimmer width="150px" height="28px" />
          <Box display="flex" css={({ theme }) => ({ gap: theme.space['8'] })}>
            <Shimmer width="132px" height="48px" />
            {showSortFilter && <Shimmer width="156px" height="48px" />}
          </Box>
        </Box>

        {showAutomaticAccountUpdatesToggle && (
          <Box display="flex" alignItems="center">
            <Shimmer width="320px" height="24px" />
          </Box>
        )}
      </Box>

      <Box my="24">
        <Box mb="12">
          <Shimmer width="180px" height="22px" />
        </Box>
        <Box border="1px solid" borderRadius="medium" borderColor="neutral.300">
          {times(4).map(key => (
            <Box
              key={key}
              display="flex"
              alignItems="center"
              p="16"
              borderTop={key === 0 ? 'none' : '1px solid'}
              borderColor="neutral.300"
            >
              <UserActivityItemLoading />
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};
